<template>
  <div class="">
    <div class="top-section w-full h-full px-5">
      <div class="flex justify-between px-4 py-4">
        <div class="sm:flex sm:justify-between w-full items-start md:block left text-center sm:text-left">
          <h5 class="text-2xl md:text-2xl font-bold mb-5 text-white">Weekly Performance for Week {{ week_number}} ({{weekStart}}  - {{ weekEnd }}) </h5>

          <select v-model="week" @change="fetchPerformance" name="" id="" class="bg-white text-dark px-8 py-3 focus:outline-none">
            <option>Select a Week</option>
            <option v-for="(week,index) in weeks" :key="index" :value="week">WEEK {{week}}</option>
          </select>
        </div>
        <div class="hidden md:block right">
          <img src="https://res.cloudinary.com/lms-edc/image/upload/v1594517172/Assets/chovh7jpbkgd4ixmc2fn.png" alt="">
        </div>
      </div>
    </div>
    <div class="">
      <div class="w-full p-8">
        <div class="flex flex-wrap justify-center">
          <div class="w-full mb-4 shadow-md">
            <div class="tab w-full overflow-hidden border-t">
              <input class="absolute opacity-0 " id="tab-multi-one" type="checkbox" name="tabs">
              <label class="block p-5 leading-normal cursor-pointer" for="tab-multi-one">Stage One</label>
              <div class="tab-content overflow-scroll border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                <p class="p-5">The data below shows the qualified learners for this stage</p>
                <table class="table w-full">
                  <tr>
                    <td class="py-2 px-4 font-semibold">First Name</td>
                    <td class="py-2 px-4 font-semibold">Last Name</td>
                    <td class="py-2 px-4 font-semibold">Gender</td>
                    <td class="py-2 px-4 font-semibold">Contact</td>
                  </tr>
                  <tr v-for="stage in performance.stage_one" :key="stage.id">
                    <td class="px-4 border-b py-5">{{ stage.first_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.last_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.gender }}</td>
                    <td class="px-4 border-b py-5">{{ stage.contact }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="w-full mb-4">
            <div class="tab w-full overflow-hidden border-t shadow-md">
              <input class="absolute opacity-0 " id="tab-multi-two" type="checkbox" name="tabs">
              <label class="block p-5 leading-normal cursor-pointer" for="tab-multi-two">Stage Two</label>
              <div class="tab-content overflow-hidden border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                <p class="p-5">The data below shows the qualified learners for this stage</p>
                <table class="table w-full">
                  <tr>
                    <td class="py-2 px-4 font-semibold">First Name</td>
                    <td class="py-2 px-4 font-semibold">Last Name</td>
                    <td class="py-2 px-4 font-semibold">Gender</td>
                    <td class="py-2 px-4 font-semibold">Contact</td>
                  </tr>
                  <tr v-for="stage in performance.stage_two" :key="stage.id">
                    <td class="px-4 border-b py-5">{{ stage.first_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.last_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.gender }}</td>
                    <td class="px-4 border-b py-5">{{ stage.contact }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="w-full mb-4 shadow-md">
            <div class="tab w-full overflow-hidden border-t">
              <input class="absolute opacity-0 " id="tab-multi-three" type="checkbox" name="tabs">
              <label class="block p-5 leading-normal cursor-pointer" for="tab-multi-three">Stage Three</label>
              <div class="tab-content overflow-scroll border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                <p class="p-5">The data below shows the qualified learners for this stage</p>
                <table class="table w-full">
                  <tr>
                    <td class="py-2 px-4 font-semibold">First Name</td>
                    <td class="py-2 px-4 font-semibold">Last Name</td>
                    <td class="py-2 px-4 font-semibold">Gender</td>
                    <td class="py-2 px-4 font-semibold">Contact</td>
                  </tr>
                  <tr v-for="stage in performance.stage_three" :key="stage.id">
                    <td class="px-4 border-b py-5">{{ stage.first_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.last_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.gender }}</td>
                    <td class="px-4 border-b py-5">{{ stage.contact }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="w-full mb-4 shadow-md">
            <div class="tab w-full overflow-hidden border-t">
              <input class="absolute opacity-0 " id="tab-multi-four" type="checkbox" name="tabs">
              <label class="block p-5 leading-normal cursor-pointer" for="tab-multi-four">Stage Four</label>
              <div class="tab-content overflow-scroll border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                <p class="p-5">The data below shows the qualified learners for this stage</p>
                <table class="table w-full">
                  <tr>
                    <td class="py-2 px-4 font-semibold">First Name</td>
                    <td class="py-2 px-4 font-semibold">Last Name</td>
                    <td class="py-2 px-4 font-semibold">Gender</td>
                    <td class="py-2 px-4 font-semibold">Contact</td>
                  </tr>
                  <tr v-for="stage in performance.stage_four" :key="stage.id">
                    <td class="px-4 border-b py-5">{{ stage.first_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.last_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.gender }}</td>
                    <td class="px-4 border-b py-5">{{ stage.contact }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="w-full mb-4 shadow-md">
            <div class="tab w-full overflow-hidden border-t">
              <input class="absolute opacity-0 " id="tab-multi-five" type="checkbox" name="tabs">
              <label class="block p-5 leading-normal cursor-pointer" for="tab-multi-five">Stage Five</label>
              <div class="tab-content overflow-scroll border-l-2 bg-gray-100 border-indigo-500 leading-normal">
                <p class="p-5">The data below shows the qualified learners for this stage</p>
                <table class="table w-full">
                  <tr>
                    <td class="py-2 px-4 font-semibold">First Name</td>
                    <td class="py-2 px-4 font-semibold">Last Name</td>
                    <td class="py-2 px-4 font-semibold">Gender</td>
                    <td class="py-2 px-4 font-semibold">Contact</td>
                  </tr>
                  <tr v-for="stage in performance.stage_five" :key="stage.id">
                    <td class="px-4 border-b py-5">{{ stage.first_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.last_name }}</td>
                    <td class="px-4 border-b py-5">{{ stage.gender }}</td>
                    <td class="px-4 border-b py-5">{{ stage.contact }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "weekly_performance",
  data(){
    return {
      performance:{},
      week_number:'',
      week:'',
      weekStart: '',
      weekEnd: '',
      weeks: ''
    };
  },
  methods:{
    ...mapActions(['getPerformance']),
    ...mapMutations(['updateLoader']),
    async fetchPerformance(){
      this.updateLoader(true)
      try {
        const res = await this.getPerformance({week:this.week});
        this.performance = res.data.performance;
        //console.log(res)
        this.updateLoader(false)
      } catch (e) {
        this.updateLoader(false)
      }
    },
    getCurrentWeek(){
      this.week_number =  moment().format("W")
      this.week =  moment().format("WW")
      this.weekStart = moment().startOf('week').format('LL');
      this.weekEnd = moment().endOf('week').format('LL');
      this.weeks = moment().weeksInWeekYear()
    }
  },
  async mounted(){
    await this.getCurrentWeek()
    await this.fetchPerformance();
  }
}
</script>

<style>
/* Tab content - closed */
.tab-content {
  max-height: 0;
  -webkit-transition: max-height .35s;
  -o-transition: max-height .35s;
  transition: max-height .35s;
}
/* :checked - resize to full height */
.tab input:checked ~ .tab-content {
  max-height: 100vh;
}
/* Label formatting when open */
.tab input:checked + label{
  /*@apply text-xl p-5 border-l-2 border-indigo-500 bg-gray-100 text-indigo*/
  font-size: 1.25rem; /*.text-xl*/
  padding: 1.25rem; /*.p-5*/
  border-left-width: 2px; /*.border-l-2*/
  border-color: #6574cd; /*.border-indigo*/
  background-color: #f8fafc; /*.bg-gray-100 */
  color: #6574cd; /*.text-indigo*/
}
/* Icon */
.tab label::after {
  float:right;
  right: 0;
  top: 0;
  display: block;
  width: 1.5em;
  height: 1.5em;
  line-height: 1.5;
  font-size: 1.25rem;
  text-align: center;
  -webkit-transition: all .35s;
  -o-transition: all .35s;
  transition: all .35s;
}
/* Icon formatting - closed */
.tab input[type=checkbox] + label::after {
  content: "+";
  font-weight:bold; /*.font-bold*/
  border-width: 1px; /*.border*/
  border-radius: 9999px; /*.rounded-full */
  border-color: #b8c2cc; /*.border-grey*/
}
.tab input[type=radio] + label::after {
  content: "\25BE";
  font-weight:bold; /*.font-bold*/
  border-width: 1px; /*.border*/
  border-radius: 9999px; /*.rounded-full */
  border-color: #b8c2cc; /*.border-grey*/
}
/* Icon formatting - open */
.tab input[type=checkbox]:checked + label::after {
  transform: rotate(315deg);
  background-color: #6574cd; /*.bg-indigo*/
  color: #f8fafc; /*.text-grey-lightest*/
}
.tab input[type=radio]:checked + label::after {
  transform: rotateX(180deg);
  background-color: #6574cd; /*.bg-indigo*/
  color: #f8fafc; /*.text-grey-lightest*/
}
</style>

<style lang="scss">
.top-section{
  background-color: #2E3A6E;
}
</style>
